interface CarIconProps {
  color: string;
}

function CarIcon({ color = "#8eadcb" }: CarIconProps) {
  return (
    <svg
      width="24"
      height="11"
      viewBox="0 0 24 11"
      color={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9629 4.07743C22.5442 3.93743 19.6315 3.30087 19.6315 3.30087C19.6315 3.30087 14.2321 0.230469 13.5841 0.230469C12.9361 0.230469 8.49107 0.232444 8.49107 0.232444C7.40504 0.232444 6.49743 1.06003 5.44658 2.01818C4.95132 2.46964 4.40467 2.96649 3.8017 3.40844L1.55601 3.70704C1.23151 3.81051 0.99646 4.11414 0.99646 4.4729V7.04589C0.99646 7.48993 1.35637 7.84991 1.80045 7.84991H3.34361C3.45569 9.14144 4.54206 10.1583 5.86218 10.1583C7.18222 10.1583 8.26866 9.1414 8.38074 7.84995H15.7492C15.8613 9.14148 16.9477 10.1583 18.2678 10.1583C19.5879 10.1583 20.6743 9.1414 20.7864 7.84995H22.0541C23.0587 7.84995 23.5495 7.41609 23.6728 7.00884C23.9845 5.97826 23.7603 4.34401 22.9629 4.07743ZM5.86218 8.93964C5.13982 8.93964 4.55209 8.35199 4.55209 7.62963C4.55209 6.90727 5.13974 6.31954 5.86218 6.31954C6.58454 6.31954 7.17219 6.90719 7.17219 7.62963C7.17223 8.35199 6.58454 8.93964 5.86218 8.93964ZM10.7251 3.30095H6.33156C6.64935 3.04987 6.94318 2.78337 7.21386 2.53665C7.92526 1.88802 8.53968 1.3278 9.27486 1.3278C9.27486 1.3278 9.94019 1.3275 10.7252 1.32717V3.30095H10.7251ZM11.795 1.32676C12.3387 1.32657 12.8234 1.32642 13.0666 1.32642C13.6721 1.32642 16.1281 2.75265 17.0498 3.30098H11.795V1.32676ZM18.2678 8.93964C17.5454 8.93964 16.9577 8.35199 16.9577 7.62963C16.9577 6.90727 17.5454 6.31954 18.2678 6.31954C18.9901 6.31954 19.5778 6.90719 19.5778 7.62963C19.5778 8.35199 18.9901 8.93964 18.2678 8.93964Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CarIcon;
